// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1fhxb","label":"Labeled_label__3GE7q","divider":"Labeled_divider__7P-hr"};